"use client";

import * as Tooltip from "@radix-ui/react-tooltip";
import { AnimatePresence, motion } from "framer-motion";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

const languages = [
  {
    locale: "pt",
    flag: (
      <svg
        width="32"
        height="32"
        viewBox="0 0 52 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          width="51.2851"
          height="38.4638"
          transform="translate(0.415527 0.639893)"
          fill="#2B9F5A"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M26.0582 5.44788L5.22363 19.8718L26.0582 34.2958L46.8928 19.8718L26.0582 5.44788Z"
          fill="#FFD018"
        />
        <path
          d="M35.6738 19.8718C35.6738 25.1826 31.3686 29.4878 26.0579 29.4878C20.7471 29.4878 16.4419 25.1826 16.4419 19.8718C16.4419 14.5611 20.7471 10.2559 26.0579 10.2559C31.3686 10.2559 35.6738 14.5611 35.6738 19.8718Z"
          fill="#41479B"
        />
        <mask
          id="mask0_1_30"
          maskUnits="userSpaceOnUse"
          x="16"
          y="10"
          width="20"
          height="20"
        >
          <path
            d="M35.6738 19.8718C35.6738 25.1826 31.3686 29.4878 26.0579 29.4878C20.7471 29.4878 16.4419 25.1826 16.4419 19.8718C16.4419 14.5611 20.7471 10.2559 26.0579 10.2559C31.3686 10.2559 35.6738 14.5611 35.6738 19.8718Z"
            fill="#41479B"
          />
        </mask>
        <g mask="url(#mask0_1_30)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14.971 17.8613L14.8394 16.6665C14.7076 15.4718 14.7078 15.4718 14.708 15.4717L14.7159 15.4709L14.7346 15.4689L14.8026 15.462C14.8611 15.4561 14.9459 15.448 15.0548 15.4384C15.2724 15.4192 15.5866 15.3942 15.9798 15.3699C16.7656 15.3213 17.8709 15.2755 19.1563 15.2859C21.7081 15.3066 25.0499 15.5491 28.0196 16.478C30.9686 17.4005 33.4784 18.8266 35.2423 20.0113C36.1272 20.6056 36.8317 21.1441 37.3181 21.5368C37.5614 21.7333 37.7507 21.8937 37.8811 22.0068C37.9463 22.0634 37.9969 22.1082 38.0322 22.1398L38.0737 22.1772L38.0857 22.1882L38.0895 22.1917C38.0897 22.1919 38.0918 22.1938 37.2767 23.0772C36.4615 23.9605 36.4617 23.9607 36.4619 23.9608L36.4563 23.9558L36.4284 23.9306C36.4023 23.9072 36.3613 23.8708 36.306 23.8229C36.1954 23.727 36.0278 23.5848 35.8079 23.4073C35.3678 23.0519 34.72 22.5564 33.902 22.007C32.2603 20.9044 29.9621 19.6045 27.3019 18.7724C24.6623 17.9467 21.5934 17.7098 19.1368 17.6898C17.918 17.6799 16.8698 17.7234 16.1281 17.7693C15.7576 17.7922 15.4644 17.8156 15.2658 17.8331C15.1664 17.8419 15.0908 17.8491 15.041 17.8541L14.986 17.8597L14.971 17.8613Z"
            fill="#F5F8FB"
          />
        </g>
        <path
          d="M22.8527 23.8785C22.8527 24.321 22.4939 24.6798 22.0513 24.6798C21.6088 24.6798 21.25 24.321 21.25 23.8785C21.25 23.4359 21.6088 23.0771 22.0513 23.0771C22.4939 23.0771 22.8527 23.4359 22.8527 23.8785Z"
          fill="#F5F8FB"
        />
        <path
          d="M27.6608 25.4811C27.6608 25.9237 27.302 26.2825 26.8594 26.2825C26.4169 26.2825 26.0581 25.9237 26.0581 25.4811C26.0581 25.0386 26.4169 24.6798 26.8594 24.6798C27.302 24.6798 27.6608 25.0386 27.6608 25.4811Z"
          fill="#F5F8FB"
        />
        <path
          d="M30.8658 23.8785C30.8658 24.321 30.5071 24.6798 30.0645 24.6798C29.622 24.6798 29.2632 24.321 29.2632 23.8785C29.2632 23.4359 29.622 23.0771 30.0645 23.0771C30.5071 23.0771 30.8658 23.4359 30.8658 23.8785Z"
          fill="#F5F8FB"
        />
      </svg>
    ),
    label: "Português",
  },
  {
    locale: "en",
    flag: (
      <svg
        width="32"
        height="32"
        viewBox="0 0 52 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g opacity="0.5">
          <rect
            x="0.0825195"
            y="0.639893"
            width="51.2852"
            height="35.2585"
            fill="#EEF3F8"
          />
          <rect
            x="0.0825195"
            y="0.639893"
            width="28.8479"
            height="22.4373"
            fill="#41479B"
          />
          <rect
            x="28.9307"
            y="0.639893"
            width="22.4373"
            height="3.20532"
            fill="#DC251C"
          />
          <rect
            x="28.9307"
            y="7.05054"
            width="22.4373"
            height="3.20532"
            fill="#DC251C"
          />
          <rect
            x="28.9307"
            y="13.4612"
            width="22.4373"
            height="3.20532"
            fill="#DC251C"
          />
          <rect
            x="28.9307"
            y="19.8718"
            width="22.4373"
            height="3.20532"
            fill="#DC251C"
          />
          <rect
            x="0.0825195"
            y="26.2825"
            width="51.2852"
            height="3.20532"
            fill="#DC251C"
          />
          <rect
            x="0.0825195"
            y="32.6931"
            width="51.2852"
            height="3.20532"
            fill="#DC251C"
          />
          <rect
            x="3.28809"
            y="3.84521"
            width="3.20532"
            height="3.20532"
            fill="#C5D0EC"
          />
          <rect
            x="9.69873"
            y="3.84521"
            width="3.20532"
            height="3.20532"
            fill="#C5D0EC"
          />
          <rect
            x="16.1094"
            y="3.84521"
            width="3.20532"
            height="3.20532"
            fill="#C5D0EC"
          />
          <rect
            x="22.52"
            y="3.84521"
            width="3.20532"
            height="3.20532"
            fill="#C5D0EC"
          />
          <rect
            x="3.28809"
            y="10.2559"
            width="3.20532"
            height="3.20532"
            fill="#C5D0EC"
          />
          <rect
            x="9.69873"
            y="10.2559"
            width="3.20532"
            height="3.20532"
            fill="#C5D0EC"
          />
          <rect
            x="16.1094"
            y="10.2559"
            width="3.20532"
            height="3.20532"
            fill="#C5D0EC"
          />
          <rect
            x="6.49316"
            y="13.4612"
            width="3.20532"
            height="3.20532"
            fill="#C5D0EC"
          />
          <rect
            x="12.9043"
            y="13.4612"
            width="3.20532"
            height="3.20532"
            fill="#C5D0EC"
          />
          <rect
            x="19.3145"
            y="13.4612"
            width="3.20532"
            height="3.20532"
            fill="#C5D0EC"
          />
          <rect
            x="6.49316"
            y="7.05054"
            width="3.20532"
            height="3.20532"
            fill="#C5D0EC"
          />
          <rect
            x="12.9043"
            y="7.05054"
            width="3.20532"
            height="3.20532"
            fill="#C5D0EC"
          />
          <rect
            x="19.3145"
            y="7.05054"
            width="3.20532"
            height="3.20532"
            fill="#C5D0EC"
          />
          <rect
            x="22.52"
            y="10.2559"
            width="3.20532"
            height="3.20532"
            fill="#C5D0EC"
          />
          <rect
            x="3.28809"
            y="16.6665"
            width="3.20532"
            height="3.20532"
            fill="#C5D0EC"
          />
          <rect
            x="9.69873"
            y="16.6665"
            width="3.20532"
            height="3.20532"
            fill="#C5D0EC"
          />
          <rect
            x="16.1094"
            y="16.6665"
            width="3.20532"
            height="3.20532"
            fill="#C5D0EC"
          />
          <rect
            x="22.52"
            y="16.6665"
            width="3.20532"
            height="3.20532"
            fill="#C5D0EC"
          />
        </g>
      </svg>
    ),
    label: "English",
  },
  {
    locale: "es",
    flag: (
      <svg
        width="32"
        height="32"
        viewBox="0 0 53 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g opacity="0.5">
          <rect
            width="51.2852"
            height="38.4639"
            transform="translate(0.749512 0.639893)"
            fill="#FFD018"
          />
          <rect
            x="0.749512"
            y="0.639893"
            width="51.2852"
            height="9.61597"
            fill="#DC251C"
          />
          <rect
            x="0.749512"
            y="29.4878"
            width="51.2852"
            height="9.61597"
            fill="#DC251C"
          />
          <rect
            x="10.3652"
            y="13.4612"
            width="6.41064"
            height="6.41064"
            fill="#DC251C"
          />
          <path
            d="M10.3652 19.8718H16.7759V26.2825H13.5706C11.8003 26.2825 10.3652 24.8474 10.3652 23.0771V19.8718Z"
            fill="#FF8718"
          />
          <path
            d="M16.7764 19.8718H23.187V23.0771C23.187 24.8474 21.7519 26.2825 19.9817 26.2825H16.7764V19.8718Z"
            fill="#DC251C"
          />
          <rect
            x="16.7764"
            y="13.4612"
            width="6.41064"
            height="6.41064"
            fill="#A6A6A6"
          />
          <circle cx="16.776" cy="19.8718" r="1.60266" fill="#41479B" />
        </g>
      </svg>
    ),
    label: "Español",
  },
  {
    locale: "ar",
    flag: (
      <svg
        width="32"
        height="32"
        viewBox="0 0 52 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g opacity="0.5">
          <rect
            x="0.416504"
            y="13.4502"
            width="51.373"
            height="12.8433"
            fill="#F5F8FB"
          />
          <rect
            x="0.416504"
            y="0.606934"
            width="51.373"
            height="12.8433"
            fill="#2B9F5A"
          />
          <rect
            x="0.416504"
            y="26.2935"
            width="51.373"
            height="12.8433"
            fill="#272727"
          />
          <rect
            x="0.416504"
            y="0.606934"
            width="16.0541"
            height="38.5298"
            fill="#DC251C"
          />
        </g>
      </svg>
    ),
    label: "العربية",
  },
] as const;

export function LanguageSwitcher() {
  const router = useRouter();
  const [mounted, setMounted] = useState(false);
  const currentLocale = router.locale || router.defaultLocale || "en";

  useEffect(() => {
    setMounted(true);
  }, []);

  const handleChangeLanguage = (newLocale: string) => {
    const pathAfterLocale = router.pathname.split("/").slice(2).join("/");
    const newPath = `/${newLocale}/${pathAfterLocale}`;
    localStorage.setItem("localeLanguage", newLocale);
    router.replace(newPath);
  };

  if (!mounted) return null;

  return (
    <Tooltip.Provider delayDuration={300}>
      <div className="flex gap-2 mt-3">
        <AnimatePresence mode="wait">
          {languages.map(({ locale, flag, label }) => {
            const isSelected = locale === currentLocale;

            return (
              <Tooltip.Root key={locale}>
                <Tooltip.Trigger asChild>
                  <motion.div
                    className={`relative cursor-pointer p-0 m-0`}
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: isSelected ? 1 : 0.2, y: 0 }}
                    exit={{ opacity: 0, y: 10 }}
                    transition={{ duration: 0.2 }}
                    onClick={() => handleChangeLanguage(locale)}
                  >
                    <div className="rounded-lg transition-colors hover:opacity-100">
                      <span className="block w-8 h-8">{flag}</span>
                    </div>
                  </motion.div>
                </Tooltip.Trigger>
                <Tooltip.Portal>
                  <Tooltip.Content
                    className="bg-app-gray-800 text-white px-2 py-1 rounded text-sm"
                    sideOffset={5}
                  >
                    {label}
                    <Tooltip.Arrow className="fill-app-gray-800" />
                  </Tooltip.Content>
                </Tooltip.Portal>
              </Tooltip.Root>
            );
          })}
        </AnimatePresence>
      </div>
    </Tooltip.Provider>
  );
}
